import { Dialog, DialogProps } from '@mui/material'
import { styled } from '@mui/material/styles'

export const DialogStyled = styled(({ open, ...props }: DialogProps) => (
  <Dialog open={open} {...props} />
))({
  '& .MuiPaper-root': {
    borderRadius: 16,
    transition: 'max-width 0.3s ease, width 0.3s ease',
  },
})
